var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/codebuild/output/src2118274201/src/tv-monitor-ui/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/js/view/pages/LoginView.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"box\">\n    <form class=\"form-login\">\n        <img class=\"xola-logo\" src=\"/img/xola-logo.png\" />\n\n        <div class=\"heading\">\n            <h3>Sign in</h3>\n            <p>to continue to <b>xola.tv</b></p>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"form-login-username\" class=\"control-label\">Email address</label>\n            <input id=\"form-login-username\" class=\"form-control\" type=\"email\" name=\"username\" placeholder=\"john.doe@example.com\" autofocus required />\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"form-login-password\" class=\"control-label\">Password</label>\n            <input type=\"password\" id=\"form-login-password\" class=\"form-control\" name=\"password\" placeholder=\"P@$$w0rd\" required />\n            <span class=\"help-block error\">There was an issue signing you into Xola. Check your email and password and try again.</span>\n        </div>\n\n        <div class=\"checkbox\">\n            <label>\n                <input type=\"checkbox\" name=\"rememberMe\" value=\"1\"> Remember me\n            </label>\n        </div>\n\n        <div class=\"actions text-right\">\n            <button class=\"btn btn-success\" type=\"submit\">Next</button>\n        </div>\n    </form>\n\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/js/view/pages/LoginView.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/js/view/pages/LoginView.njk
// module id = 245
// module chunks = 0